import { render, staticRenderFns } from "./commentelement.vue?vue&type=template&id=7e396b57&"
import script from "./../../ts/articleattributes/commentelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/commentelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports